import React from 'react';
import LabelReportGroupedItemTable from './LabelReportGroupedItemTable';

const LabelReportGroupedProducts: React.FC = () => (
  <LabelReportGroupedItemTable
    dataKey='groupedProducts'
    tableId='LabelReportGroupedProducts'
  />
);

export default LabelReportGroupedProducts;
